/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const RelaxedIcon = props => {
	const { color = '' } = props
	return (
		<svg
			id='Layer_1'
			xmlns='http://www.w3.org/2000/svg'
			x={0}
			y={0}
			viewBox='0 0 50 50'
			style={{
				enableBackground: 'new 0 0 50 50'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			fill={color}
			{...props}
		>
			<path
				className='st0'
				d='M25 0C11.2 0 0 11.2 0 25s11.2 25 25 25 25-11.2 25-25S38.8 0 25 0zm0 48.2C12.2 48.3 1.8 37.8 1.8 25 1.8 12.2 12.2 1.8 25 1.8c12.8 0 23.2 10.4 23.3 23.2 0 12.8-10.4 23.2-23.3 23.2z'
			/>
			<path
				className='st0'
				d='M25.4 37.9c-4.2 0-7.9-2.8-9.2-6.8v-.4c0-.7.6-1.3 1.3-1.3.6 0 1.1.4 1.2.9.9 3 3.6 4.9 6.7 4.9h.1c3 0 5.7-2 6.6-4.8v-.1c.1-.3.3-.6.6-.8.3-.2.7-.2 1-.1.3.1.6.3.8.6.2.3.2.7.1 1-1.3 4.1-5 6.8-9.2 6.9zM21 19.8c.1-.7-.5-1.3-1.2-1.4-.7 0-1.3.5-1.4 1.2-.1.9-.5 1.6-1.1 2.2s-1.5.8-2.3.7h-.1c-1.2.1-2.3-.4-3-1.3-.3-.4-.5-.8-.5-1.3-.1-.7-.7-1.1-1.4-1.1-.3 0-.7.2-.9.4-.2.3-.4.6-.3 1 .4 2.8 2.9 4.9 5.6 4.9h.7c2.9.1 5.6-2.2 5.9-5.3zM39.3 18.4c-.7-.1-1.4.5-1.4 1.2-.2 1.8-1.8 3.1-3.6 3-3.1 0-3.4-2.2-3.4-2.6 0-.3-.2-.7-.4-.9s-.6-.4-.9-.3c-.3 0-.7.2-.9.4-.2.3-.4.6-.3.9v.1c.3 2.9 2.7 5.1 5.5 5.1h.6c3.1.2 5.9-2.2 6.2-5.3-.1-.9-.7-1.6-1.4-1.6z'
			/>
		</svg>
	)
}

export default RelaxedIcon
